import { revalidateOnQueryChange } from '../../util-routing'

export const portfolioModule = [
  {
    path: '/portfolio.ashx',
    shouldRevalidate: revalidateOnQueryChange(['pid']),
    loaderBundle: () => import(/* webpackChunkName: "portfolio-view-loaders" */ './routes/View/loaders'),
    LazyComponent: () => import(/* webpackChunkName: "portfolio-view" */ './routes/View/Route'),
  },
  {
    path: '/create_new_portfolio.ashx',
    loaderBundle: () => import(/* webpackChunkName: "portfolio-empty-loaders" */ './routes/EmptyView/loaders'),
    LazyComponent: () => import(/* webpackChunkName: "portfolio-empty" */ './routes/EmptyView/Route'),
  },
  {
    path: '/portfolio_edit.ashx',
    loaderBundle: () => import(/* webpackChunkName: "portfolio-edit-loaders" */ './routes/BulkEdit/loaders'),
    LazyComponent: () => import(/* webpackChunkName: "portfolio-edit" */ './routes/BulkEdit/Route'),
  },
]
